import { render, staticRenderFns } from "./WorkCalendar.vue?vue&type=template&id=aaee19dc&scoped=true"
import script from "./WorkCalendar.vue?vue&type=script&lang=js"
export * from "./WorkCalendar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendar.vue?vue&type=style&index=0&id=aaee19dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaee19dc",
  null
  
)

export default component.exports